/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Contact_SupportInputs */

const en_auth_contact_support = /** @type {(inputs: Auth_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Having issues? Contact support`)
};

const es_auth_contact_support = /** @type {(inputs: Auth_Contact_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Tienes problemas? Contacta soporte`)
};

/**
* | output |
* | --- |
* | "Having issues? Contact support" |
*
* @param {Auth_Contact_SupportInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_contact_support = /** @type {((inputs?: Auth_Contact_SupportInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Contact_SupportInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_contact_support(inputs)
	return en_auth_contact_support(inputs)
});